const form = document.getElementById('newsletter-form');
if (form) {
  form.addEventListener('submit', e => {
    e.preventDefault();
    fetch('https://mobilearts.activehosted.com/proc.php', {
      method: 'POST',
      mode: 'no-cors',
      body: new URLSearchParams(new FormData(form))
    });
    form.innerHTML = '<p>Bedankt voor je inschrijving!</p>';
  });
}
